import React, { useState, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import Navbar from './Navbar';
import Home from "./routes/Home";
import About from "./routes/About";
import Team from "./routes/Team";
import Progress from "./routes/Progress";
import Resources from "./routes/Resources";
import Project from "./routes/Project";
import fetchGitHubOrgProjectData from "./controller/GithubData";

/**
 * Root component of the AnchorTech Solutions React website.
 * Manages application routing and global state of the group organization project data fetched from GitHub GraphQL API.
 */
function App() {
    const [githubOrgData, setGithubOrgData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGitHubOrgProjectData()
            .then(data => {
                setGithubOrgData(data);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    let formattedProjectTaskData,
        formattedOrgDisplayData,
        formattedOrgMemberData;
    if (loading) {
        formattedProjectTaskData = <p>Loading project task progress data...</p>;
        formattedOrgDisplayData = <p>Loading GitHub organisation data...</p>;
        formattedOrgMemberData = <p>Loading project member contributor data...</p>;
    } else if (error) {
        formattedProjectTaskData = <p>Error fetching project progress data: { error }</p>;
        formattedOrgDisplayData = <p>Error fetching GitHub organisation data: { error }</p>;
        formattedOrgMemberData = <p>Error fetching project member data: { error }</p>;
    } else {
        formattedProjectTaskData = <Progress formattedProjectTaskData={ githubOrgData[0] } />;
        formattedOrgDisplayData = <Project formattedOrgDisplayData={ githubOrgData[1] } />;
        formattedOrgMemberData = <Team formattedOrgMemberData={ githubOrgData[2] } />;
    }

    return (
        <>
            <Navbar/>
            <Routes>
                <Route path="/" element={ <Home/> }/>
                <Route path="/about" element={ <About/> }/>
                <Route path="/team" element={ formattedOrgMemberData }/>
                <Route path="/progress" element={ formattedProjectTaskData }/>
                <Route path="/resources" element={ <Resources/> }/>
                <Route path="/project" element={ formattedOrgDisplayData }/>
            </Routes>
        </>
    );
}

export default App;
